import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { WorkAreaFilterCategories } from 'src/constants/workAreaFilterCategories';
import { DropDownCategories } from 'src/types/generic';
import { UserTreeFilterBy } from 'src/types/work_area';

/** Maps dropdown option value to tree filter type. Single source of truth for value → filter. */
export function getFilterByFromOptionValue(value: number | undefined | null): UserTreeFilterBy {
  if (value === 1) return 'ShowActive';
  if (value === 2) return 'ShowDisabled';
  return 'ShowAll';
}

/** Shared localized filter options for Company Tree and User Companies (Show All / Show Active / Show Disabled). */
export function useWorkAreaFilterOptions(): DropDownCategories[] {
  const { t } = useTranslation();
  return useMemo(
    () =>
      WorkAreaFilterCategories.map((option) => ({
        ...option,
        label:
          option.value === 0
            ? t('showAll')
            : option.value === 1
              ? t('showActive')
              : t('showDisabled'),
      })),
    [t]
  );
}
